const doc = [({"en":({"adminConstantHotelWaitingListType":({"disabledWaitingList":"Disabled", "enabledWaitingList":"Enabled"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;